import { InjectionToken } from '@angular/core';
import { NormalizedError } from './error.types';

export interface ErrorDialogPort {
    open(error: NormalizedError, options?: { width?: string }): void;
}

export const ERROR_DIALOG_PORT = new InjectionToken<ErrorDialogPort>(
    'ERROR_DIALOG_PORT'
);
